import pickBy from 'lodash/pickBy';
import kebabCase from 'lodash/kebabCase';

// this is needed because prop names can be like `asButton`
// but prop values can also be like `3s` which would convert to `3-s` with kebabCase
const modifierToKebabCase = (str) => {
  const kebabbed = kebabCase(str);
  return kebabbed.replace(/[0-9]-[a-zA-Z]/g, (match) => match.replace('-', ''));
};

export const getModifierClass = (block, value) => `${block}--${modifierToKebabCase(value)}`;

export default {
  computed: {
    baseClass() {
      const noPrefix = this.$options.name.slice(1);
      return kebabCase(noPrefix);
    },
    classes() {
      const classes = [this.baseClass];
      const props = pickBy(this.$options.props, ({ cssClass }) => cssClass);
      const valuesProps = pickBy(props, ({ type }) => type !== Boolean);
      const booleansProps = pickBy(props, ({ type }) => type === Boolean);
      const values = Object.keys(valuesProps)
        .map((name) => getModifierClass(this.baseClass, `${name}-${this[name]}`));
      const booleans = Object.keys(booleansProps)
        .filter((name) => this[name])
        .map((name) => getModifierClass(this.baseClass, name));
      classes.push(...values, ...booleans);
      return classes;
    },
  },
};
